// extracted by mini-css-extract-plugin
export default {"feedback-tips-title":"TooltipMessage_feedback-tips-title__PHatr","feedback-tips":"TooltipMessage_feedback-tips__KwifI"};